// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.c2-space[data-v-942a2bf4] {\n  width: 100% !important;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n.c2-space-horizontal[data-v-942a2bf4] {\n  -ms-flex-align: center;\n  -webkit-box-align: center;\n          align-items: center;\n}\n.c2-space-vertical[data-v-942a2bf4] {\n  -ms-flex-direction: column;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n          flex-direction: column;\n}\n", ""]);
// Exports
module.exports = exports;
